export type EntryPoint =
  | "discover_list"
  | "discover_map"
  | "share_link"
  | "other";

/** The `ref` a link carries. A link without one is a share link. */
export type LinkEntryPoint = Exclude<EntryPoint, "share_link">;

/**
 * Extract event ID from signup URL pattern:
 * ${SPOND_CLUB_BASE_URL}/landing/courses/${clubShortId}/${eventId}
 */
export function extractEventIdFromHref(
  href: string | undefined,
): string | null {
  if (!href) return null;
  try {
    const url = new URL(href);
    const segments = url.pathname.split("/").filter(Boolean);
    // Pattern: /landing/courses/{clubShortId}/{eventId}
    if (
      segments.length >= 4 &&
      segments[0] === "landing" &&
      segments[1] === "courses"
    ) {
      return segments[3] ?? null;
    }
    return null;
  } catch {
    return null;
  }
}

export function getEntryPoint(ref: string | null): EntryPoint {
  if (ref === "discover_list") return "discover_list";
  if (ref === "discover_map") return "discover_map";
  if (ref === "other") return "other";
  return "share_link";
}
